import { takeLatest, call, put, all } from 'redux-saga/effects';
import { get, occupancyList } from '@api';
import { HttpResponse } from '@api/interfaces';
import { loaderActions, occupancyActions } from '@actions';
import { BaseAction } from '@constants';

interface IOccupancy extends HttpResponse<Response> {
    parsedBody: any;
}

function* requestOccupancy(action: BaseAction) {
    try {
        const { projectId } = action.payload;
        const projectCid: string = sessionStorage.getItem('projectCid') || '';
        const params: string = yield call(occupancyList, projectId, projectCid);
        const resOccupancy: IOccupancy = yield call(get, params);

        yield put({
            type: occupancyActions.OccupancyActions.REQUESTOCCUPANCYSUCCESS,
            payload: resOccupancy.parsedBody,
        });
    } catch (error) {
        yield put({
            type: occupancyActions.OccupancyActions.REQUESTOCCUPANCYERROR,
            payload: JSON.stringify(error),
        });
        yield put({
            type: loaderActions.LoaderEnum.LOADERRERROR,
            payload: {
                loading: false,
                mapOverlay: false,
            },
        });
    }
}

function* OccupancySaga() {
    yield takeLatest(occupancyActions.OccupancyActions.REQUESTOCCUPANCY, requestOccupancy);
}

function* All() {
    yield all([OccupancySaga()]);
}

export default All;
